// Homepage component
import React, { useState, useEffect } from 'react';
import '../assets/styles/pages.css';

const Homepage = () => {
  const [textIndex, setTextIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const array = ["Software Engineer", "Quality Engineer", "Test Architect", "Open Source Contributor", "Aspiring AI Engineer"];

  useEffect(() => {
    
    document.title = "Home | Christian Ansel";

    const intervalId = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setTextIndex(prevIndex => (prevIndex + 1) % array.length);
        setIsVisible(true);
      }, 1000);
    }, 2000);

    return () => clearInterval(intervalId);
  }, [array.length]);

  return (
    <div id="homepage-content" className="flex justify-center items-center">
      <div id="homepage" className="flex flex-col items-center justify-center">
        <div className="text-center mb-4">
          <h1 className="text-9xl">Hello, I'm Ansel</h1>
        </div>
        <div className={`text-center text-5xl ${isVisible ? 'animate-fade-in' : 'animate-fade-out'}`}>
          <h2 className='font-bold'>{array[textIndex]}</h2>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
